import React, { useState } from "react";
import { Box, Grid, Typography, TextField, Button, IconButton } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material";
import { Link } from "react-router-dom";

const Footer = () => {
  // State to store the mobile number input
  const [mobileNumber, setMobileNumber] = useState("");

  // Handle input change
  const handleMobileChange = (event) => {
    setMobileNumber(event.target.value);
  };

  // Handle subscribe click to redirect to WhatsApp
  const handleSubscribe = () => {
    // Ensure the mobile number is in the correct format (e.g., removing any non-numeric characters)
    const formattedNumber = mobileNumber.replace(/\D/g, ""); // Remove any non-digit characters

    // Check if the number is not empty
    if (formattedNumber) {
      const whatsappUrl = `https://wa.me/+971524346217`;
      window.open(whatsappUrl, "_blank"); // Open WhatsApp in a new tab
    } else {
      alert("Please enter a valid mobile number.");
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#8BC34A",
        color: "white",
        padding: "40px 20px",
        fontSize: "14px",
      }}
    >
      <Grid container spacing={4}>
        {/* Logo and Address Section */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            C.G.L GENERAL TRADING LLC.
          </Typography>
          <Typography sx={{ marginTop: "10px", lineHeight: "1.8" }}>
            Umm-Ramool, Dubai, UAE
            <br />
            0525121661
            <br />
            E-Mail: cglholdings@aol.com
            <br />
            Tel: +971524346217
            <br />
            Landline: +97145588324
          </Typography>
        </Grid>

        {/* About Section */}
        <Grid item xs={12} md={2}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Links
          </Typography>
          <Typography sx={{ marginTop: "10px", lineHeight: "2" }}>
            <div>
              <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
                Home
              </Link>
            </div>
            <div>
              <Link to="/aboutus" style={{ textDecoration: "none", color: "inherit" }}>
                About Us
              </Link>
            </div>
            <div>
              <Link to="/contactus" style={{ textDecoration: "none", color: "inherit" }}>
                Contact Us
              </Link>
            </div>
          </Typography>
        </Grid>

        {/* Resources Section */}
        <Grid item xs={12} md={2}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Products
          </Typography>
          <Typography sx={{ marginTop: "10px", lineHeight: "2" }}>
            <div>
              <Link to="/sonxproducts" style={{ textDecoration: "none", color: "inherit" }}>
                Son-X
              </Link>
            </div>
            <div>
              <Link to="/foodproducts" style={{ textDecoration: "none", color: "inherit" }}>
                My Food
              </Link>
            </div>
          </Typography>
        </Grid>

        {/* Get in Touch Section */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Get in touch
          </Typography>
          <Typography sx={{ marginTop: "10px", lineHeight: "1.8" }}>
            The latest products news, articles, sent to your inbox weekly.
          </Typography>
          <Box sx={{ marginTop: "10px", display: "flex" }}>
            <TextField
              placeholder="Mobile Number"
              variant="outlined"
              size="small"
              sx={{
                backgroundColor: "white",
                borderRadius: "4px",
                flex: 1,
                marginRight: "10px",
              }}
              value={mobileNumber}
              onChange={handleMobileChange} // Capture the mobile number
            />
            <Button
              variant="contained"
              sx={{ backgroundColor: "white", color: "#8BC34A" }}
              onClick={handleSubscribe} // Handle the subscribe click
            >
              Subscribe
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* Footer Bottom */}
      <Box
        sx={{
          marginTop: "30px",
          borderTop: "1px solid rgba(255, 255, 255, 0.2)",
          paddingTop: "10px",
          textAlign: "center",
        }}
      >
        <Typography sx={{ marginBottom: "10px" }}>2025@C.G.L. All rights reserved.</Typography>
        <Box>
          <IconButton sx={{ color: "white" }}>
            <a href="https://www.facebook.com/share/15ZPoWoCy8/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
              <Facebook />
            </a>
          </IconButton>
          <IconButton sx={{ color: "white" }}>
            <a href="https://www.instagram.com/cglgeneraltradingdxb/profilecard/?igsh=MTE1aXdieWEzaWZoaw==" target="_blank" rel="noopener noreferrer">
              <Instagram />
            </a>
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
